import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MfaSessionIssueTypesQueryVariables } from '../MfaSessionIssueTypes.generated';

export const buildMfaSessionIssueTypesQueryVariables = (
	sessionId: string
): MfaSessionIssueTypesQueryVariables => ({
	runId: buildRunIdParam(sessionId).runId
});
